import {Platform} from 'react-native';
import {
  EditorLayer,
  EditorProject,
  EncoderProject,
  Media,
} from '../../types';
import {getFileOpfs, writeFileOpfs} from '../fs';
import {appDirectory} from '../db/defaults';
import {downloadFileById} from '../wt';
import {FFmpegKit} from 'ffmpeg-kit-react-native';
import * as ExpoFileSystem from 'expo-file-system';
const documentDir =
  Platform.OS === 'web'
    ? ''
    : ExpoFileSystem.documentDirectory?.replace('file://', '') || '';
const cachedMedia: {[key: string]: string} = {};

import {
  ffmpeg,
  createFFmpeg,
  fetchFile,
  cancelEncoding,
  CBProgressCallback,
  LogsProgressCallback,
} from './ffmpeg';
import {genExecTime} from './util/genExecTime';
import {genRenderCmd} from './util/genRenderCmd';
import {defaultVideoDuration} from './util/genVideoFromImage';

export const encodeMedia = async (
  media: EncoderProject,
  cb?: CBProgressCallback,
  isPrerender?: boolean,
  cmdType: 'user' | 'custom' = 'user',
  customCmd?: string[],
): Promise<string | undefined> => {
  const id = (media.isCopy || media.id) as string;
  const nmedia = {...media, id};
  const fileId = `${id}_${media?.filename}`;
  const {encoding} = media;
  const cachedId = encoding?.lastUpdated || 0;
  console.info('cachedId', cachedId);
  const outPostfix = `.output.${cachedId}.${
    encoding?.output || 'mp4'
  }`;
  const outFileId = fileId + outPostfix;
  try {
    if (!id || id === undefined) return;

    if (cachedMedia[id]) return cachedMedia[id];
    if (cachedId === 0) {
      // const opfsFile =
      cachedMedia[id] = await getFileOpfs(nmedia);
      return cachedMedia[id];
    }
    const dirCore = await window.navigator.storage.getDirectory();
    const dir = await dirCore.getDirectoryHandle(nmedia.folderId);
    const cache = await dir.getFileHandle(`${id}_${outFileId}`);
    const file = await cache?.getFile();
    if (file) {
      cachedMedia[id] = URL.createObjectURL(file);
      return cachedMedia[id];
    }
  } catch (err) {
    console.error('get cache error', err);
  }
  cancelEncoding();
  await createFFmpeg(cb);
  try {
    let opfsFile;
    try {
      opfsFile = await getFileOpfs(nmedia);
    } catch (err) {
      if (!nmedia.torrentFile) return 'file_is_being_processed';

      return 'file_is_not_downloaded';
      // const dlFIle = await downloadFileById(
      //   nmedia.id,
      //   nmedia.folderId,
      //   cb
      //     ? progress => {
      //         cb({progress, time: 0});
      //       }
      //     : undefined,
      // );
      // console.info('dlFIle', dlFIle);
      // opfsFile = URL.createObjectURL(await dlFIle.getFile());
      // if (cachedId === 0) {
      //   return encodeMedia(media, cb, isPrerender);
      // }
    }
    const execCmd = genExecCmd(nmedia, isPrerender);
    await execEncode({
      files: [fileId],
      encoded: [opfsFile],
      outFileId,
      execCmd,
      mediaOut: nmedia,
      cb,
    });
  } catch (err) {
    console.error('ffmpeg error ', err);
  }
};

export const execEncode = async (cmd: {
  files: (string | undefined)[];
  encoded: (string | undefined)[];
  outFileId: string;
  execCmd: string[];
  mediaOut: Media;
  cb?: CBProgressCallback;
  logs?: LogsProgressCallback;
}) => {
  console.info('execEncode', cmd);
  try {
    if (Platform.OS === 'web') {
      const outFileId = cmd.outFileId;
      try {
        await Promise.all(
          cmd.encoded.map(async (opfsFile, index) => {
            const fileId = cmd.files[index];
            const fs = await fetchFile(opfsFile);
            await ffmpeg.writeFile(fileId, fs);
          }),
        );
      } catch (err) {
        console.error('load files in ffmpeg error', err);
        throw err;
      }
      console.info('after loading files into ffmpeg', cmd.execCmd);
      const exec = await ffmpeg.exec(cmd.execCmd);
      console.info('after exec', exec, outFileId);
      const data = await ffmpeg.readFile(outFileId);
      console.info('after processing', data);
      data.name = outFileId;
      const filePointer = (await writeFileOpfs(
        cmd.mediaOut,
        data,
      )) as FileSystemFileHandle;
      const file = await filePointer.getFile();
      cachedMedia[cmd.mediaOut.id] = URL.createObjectURL(file);
      console.info(
        'cachedMedia for project',
        cachedMedia[cmd.mediaOut.id],
      );
      return cachedMedia[cmd.mediaOut.id];
    }
    console.info('ffmpeg cmd', cmd.execCmd.join(' '));
    return new Promise(async resolve => {
      const exec = await FFmpegKit.executeAsync(
        cmd.execCmd.join(' '),
        async rs => {
          const url = `${documentDir}${cmd.outFileId}`;
          console.info('after exec ffmpeg', exec, url, rs.getState());
          return resolve(url);
        },
        logs => {
          console.info('ffmpeg logs', logs.getMessage());
          if (cmd.logs) cmd.logs(logs.getMessage().toString());
        },
        async stats => {
          const cbOut = {progress: 0, time: stats.getTime() * 1000};
          console.info('stats', cbOut, stats.getSpeed());
          cmd.cb && cmd.cb(cbOut);
        },
      );
    });
  } catch (err) {
    console.error('encodeProject error', err);
    throw err;
  }
};

export const encodeProject = async (
  projectData: EditorProject,
  layers: EditorLayer[],
  isPrerender?: boolean,
  cb?: CBProgressCallback,
  logs?: LogsProgressCallback,
) => {
  try {
    const cmd: ReturnType<typeof genRenderCmd> & {
      encoded?: (string | undefined)[];
      mediaOut?: EditorProject | Media;
      cb?: CBProgressCallback;
      logs?: LogsProgressCallback;
    } = genRenderCmd(projectData, layers, isPrerender);
    const id = projectData.id;
    const files = cmd.files.filter(i => i !== '-i');
    console.info(
      'encodeProject',
      projectData,
      layers,
      isPrerender,
      cmd,
    );
    const cachedId = projectData.editor?.lastUpdated || 0;
    // try {
    //     if(cachedMedia[id])
    //         return cachedMedia[id]
    //     if(cachedId === 0) {
    //         // const opfsFile =
    //         cachedMedia[id] =  await getFileOpfs(nmedia)
    //         return cachedMedia[id]
    //     }
    //     const dirCore = await window.navigator.storage.getDirectory(appDirectory)
    //     const dir = await dirCore.getDirectoryHandle(projectData.folderId)
    //     const cache = await dir.getFileHandle(`${id}_${cmd.outFileId}`);
    //     const file = await cache?.getFile()
    //     if(file) {
    //         cachedMedia[id] = URL.createObjectURL(file)
    //         return cachedMedia[id]
    //     }
    // } catch(err) {
    //     console.error("get cache error", err)
    // }
    const encoded = await Promise.all(
      cmd.medias.map(media =>
        encodeMedia(
          media!,
          progress => {
            console.info('encoding media', media.id, progress);
            if (cb) cb(progress);
          },
          isPrerender,
        ),
      ),
    );
    console.info('encoded', encoded, files, cmd.execCmd);
    cancelEncoding();
    await createFFmpeg(cb, logs);
    cmd.files = files;
    cmd.encoded = encoded.filter(i => i) as string[];
    cmd.mediaOut = projectData;
    cmd.cb = cb;
    cmd.logs = logs;
    return await execEncode(cmd);
  } catch (err) {
    console.error('encodeproject error', err);
    throw err;
  }
};

export const genExecCmd = (
  projectData: EncoderProject,
  isPrerender?: boolean,
) => {
  if (projectData?.id === undefined) return [];
  const fileId = `${projectData.id}_${projectData.filename}`;
  const {encoding} = projectData;
  const outPostfix = `.output.${encoding?.lastUpdated || 0}.${
    encoding?.output || 'mp4'
  }`;
  const outFileId = fileId + outPostfix;
  // const threads = window.navigator.hardwareConcurrency.toString();
  const extraCode: string[] =
    encoding?.code && encoding.code[0] != ''
      ? encoding.code
          .filter(i => i !== '')
          .map(i =>
            i
              .trim()
              .replace(/[\r\n]+/gm, '')
              .trim(),
          )
      : [];
  const prerenderOptionalCode = !isPrerender
    ? [
        '-ss',
        genExecTime(encoding?.start || 0),
        '-to',
        genExecTime(
          encoding?.end ||
            projectData?.duration ||
            defaultVideoDuration,
        ),
      ]
    : [];
  const execCmd = [
    '-i',
    `${documentDir}${fileId}`,
    // '-crf',
    // encoding?.compressionLevel?.toString() || '20',
    // '-threads',
    // threads,
    '-filter_complex',
    `scale=${encoding?.width || projectData.width}x${
      encoding?.height || projectData.height
    }`,
    '-preset',
    encoding?.preset || 'veryfast',
    '-movflags',
    '+faststart',
    ...prerenderOptionalCode,
    ...extraCode,
    `${documentDir}${outFileId}`,
  ];
  return execCmd;
};
